import React from 'react';
import './Legal.css';


const Termeni = () => {
  return (
    <>
    
      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-section">
            <p><strong>Ultima actualizare:</strong> 28 noiembrie 2024</p>

            <h3>1. Acceptarea termenilor</h3>
            <p>Prin utilizarea sistemului de rezervări (operat de SC CLADIDAV SRL), acceptați acești termeni și condiții.</p>

            <h3>2. Servicii oferite</h3>
            <p>SC CLADIDAV SRL oferă lecții de schi și snowboard cu instructori calificați.</p>

            <h3>3. Rezervări</h3>
            <ul>
              <li>Rezervările se fac online prin formularul de pe site</li>
              <li>Veți primi confirmarea prin email</li>
              <li>Prețurile sunt afișate în RON și includ TVA</li>
            </ul>

            <h3>4. Plăți</h3>
            <p>Metode de plată acceptate:</p>
            <ul>
              <li>Card bancar (online prin Netopia Mobilpay)</li>
              <li>Numerar (la locație)</li>
            </ul>

            <h3>5. Contact</h3>
            <p>Pentru întrebări: m_adi_i@yahoo.com</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Termeni;